/**
 * YouTube embed for course HTML.
 */
import React from "react";
import PropTypes from "prop-types";

/**
 * Renders a YouTube iframe for the given embed ID.
 *
 * @param {{ embedId: string }} props
 */
const YoutubeComponent = ({ embedId }) => (
  <div className="video-responsive">
    <iframe className="as-8-5 w-full" src={`https://www.youtube.com/embed/${embedId}`} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title="Embedded youtube" />
  </div>
);

YoutubeComponent.propTypes = {
  embedId: PropTypes.string.isRequired,
};

export default YoutubeComponent;
